import type { StateCreator } from 'zustand';
import { initialPrescriptionPadState } from '../constants';
import type { PrescriptionAssistantSliceType } from '../types';

export const resetPrescriptionPad: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  () => void
> = (set) => () =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      state.prescriptionAssistant.prescriptionPad = initialPrescriptionPadState;
    },
    false,
    'prescriptionPad/reset',
  );
